// test1328
(1328 && 0);
